import io from "socket.io-client";

export const socket = io(
  process.env.NODE_ENV === "development"
    ? "https://dev.atharo.app"
    : "https://app.atharo.app",
  {
    reconnection: false,
  }
);

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect();
  }
};

export const joinARoom = (name, room) => {
  socket.emit("joinRoom", { name: name, room: room });
};
